import { Box, Divider } from '@mui/material';
import { useApplicationContext } from '../../../../../../../context/ApplicationContext/ApplicationContext';
import { useChatContext } from '../../../../../../contexts/chat/chat.context';
import { ChatStateWithOptionalId } from '../../../../../../contexts/chat/hooks/useChats/reducer/chatListReducer.types';
import { ChatBrandStore, ChatParticipant, ChatType } from '../../../../../../types/chat.types';
import ChatFormFooter from '../../../../../form/ChatFormFooter/ChatFormFooter';
import ChatParticipantListContainer from '../../../../../form/ChatParticipantListContainer';
import useChatParticipants from '../../hooks/useChatParticipants/useChatParticipants';
import { CHAT_FOOTER_HEIGHT } from '../../utils/styles.const';
import { useChatPrivateFormContentStyles } from './chatPrivateForm.styles';

const ChatPrivateForm = () => {
  const { state: appState } = useApplicationContext();

  const { classes } = useChatPrivateFormContentStyles();

  const { state, changeQuery, loadMoreRows } = useChatParticipants();
  const {
    onClickOpenPrivateChat,
    onChangeSelectedChat,
    goToChatListOfGroup,
    selectedGroupOfRooms,
    goToGroupedRooms,
  } = useChatContext();

  const handleClick = ({
    id,
    logoUrl,
    teamType,
    privateChatId,
    commercialName,
  }: ChatParticipant) => {
    if (privateChatId) {
      onChangeSelectedChat(privateChatId);
      return;
    }

    const store: ChatBrandStore = {
      commercialName:
        teamType === 'store' ? commercialName : (appState.user?.store?.name as string),
      logoUrl: teamType === 'store' ? logoUrl : appState.user?.store?.logoUrl,
      id: teamType === 'store' ? id : (appState.user?.store?.id as string),
    };
    const brand: ChatBrandStore = {
      commercialName:
        teamType === 'brand' ? commercialName : (appState.user?.brand?.name as string),
      logoUrl: teamType === 'brand' ? logoUrl : appState.user?.brand?.logoUrl,
      id: teamType === 'brand' ? id : (appState.user?.brand?.id as string),
    };

    const chat: ChatStateWithOptionalId = {
      brand,
      title: '',
      stores: [store],
      wasRemoved: false,
      createdAt: new Date(),
      updatedAt: new Date(),
      type: ChatType.PRIVATE,
    };

    onClickOpenPrivateChat(chat);
  };

  return (
    // TODO: ESSA ESTRUTURA DE HEIGHT E FOOTER ESTA BEM PADRÃO, DA PARA COMPONETIZAR
    <Box
      sx={{
        height: '100%',
      }}
    >
      <Box className={classes.list}>
        <ChatParticipantListContainer
          selectedParticipantsLength={0}
          changeQuery={changeQuery}
          loadMoreRows={loadMoreRows}
          isLoading={state.isLoading}
          participants={state.participants}
          multiselect={false}
          onClick={handleClick}
        />
      </Box>
      <Divider />
      <Box
        sx={{
          height: CHAT_FOOTER_HEIGHT,
        }}
      >
        <ChatFormFooter
          onGoBack={() => {
            selectedGroupOfRooms && selectedGroupOfRooms.metaId
              ? goToChatListOfGroup(selectedGroupOfRooms?.metaId)
              : goToGroupedRooms();
          }}
        />
      </Box>
    </Box>
  );
};

export default ChatPrivateForm;
